import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './AboutBanner.scss';

import bannerOne from '../../assets/about/banner/banner_1.webp';
import bannerTwo from '../../assets/about/banner/banner_2.webp';

const AboutBanner = () => {
    const { t } = useTranslation();

    return (
        <section
            className="about-section"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-lg-5">
                                <div className="about-banner-text">

                                    <h2>
                                        {t('aboutBanner.title')}
                                    </h2>

                                    <p>
                                        {t('aboutBanner.description')}
                                    </p>

                                    <div className="theme-btn">
                                        <Link to="/Contact">
                                            {t('aboutBanner.button')}
                                        </Link>
                                    </div>

                                </div>
                            </div>

                            <div className="col-lg-7">
                                <div className="about-banner-img">
                                    <img
                                        src={bannerOne}
                                        alt={t('aboutBanner.imageAlt')}
                                    />

                                    <img
                                        src={bannerTwo}
                                        alt={t('aboutBanner.imageAltTwo')}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;

